import "core-js/modules/es6.string.trim.js";
import "core-js/modules/es6.array.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MapMixin from './mixin';
import { MglPopup, MglMarker, MglNavigationControl, MglGeolocateControl } from 'vue-mapbox';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinMapPublic',
  components: {
    MglPopup: MglPopup,
    MglMarker: MglMarker,
    MglNavigationControl: MglNavigationControl,
    MglGeolocateControl: MglGeolocateControl
  },
  mixins: [MapMixin],
  props: {
    detailsBaseLink: {
      type: String,
      required: false,
      "default": 'digitaltwin-mgmt'
    }
  },
  data: function data() {
    return {
      popupCoordinates: [0, 0],
      popupShown: false,
      mapLoaded: false,
      markerStyle: 'default'
    };
  },
  computed: {
    markerPopupOffset: function markerPopupOffset() {
      return this.markerStyle === 'outlined' ? [80, 0] : [10, 0];
    },
    markerWidthClass: function markerWidthClass() {
      return "pmvMarkerWidth".concat(this.markerStyle === 'outlined' ? 'Outlined' : '');
    },
    markerHeadClasses: function markerHeadClasses() {
      return ['pmvMarkerBase', "pmvMarker".concat(this.markerStyle === 'outlined' ? 'Outlined' : ''), this.markerWidthClass].join(' ');
    },
    markerImageClass: function markerImageClass() {
      return "pmvMarkerImage".concat(this.markerStyle === 'outlined' ? 'Outlined' : '');
    },
    markerLineClass: function markerLineClass() {
      return "pmvMarkerLine ".concat(this.markerStyle === 'outlined' ? 'pmvMarkerLineOutlined' : '').trim();
    },
    markerAnchorClass: function markerAnchorClass() {
      return "pmvMarkerBase pmvMarkerAnchor ".concat(this.markerStyle === 'outlined' ? 'pmvMarkerAnchorOutlined' : '').trim();
    },
    markerHeadStyle: function markerHeadStyle() {
      return this.markerStyle === 'outlined' ? "border-color: ".concat(this.markerColor) : "background-color: ".concat(this.markerColor);
    },
    markerHeadIconColor: function markerHeadIconColor() {
      return this.markerStyle === 'outlined' ? this.color : 'white';
    },
    markerLineStyle: function markerLineStyle() {
      return this.markerStyle === 'outlined' ? "border-color: ".concat(this.markerColor) : undefined;
    },
    markerAnchorStyle: function markerAnchorStyle() {
      return this.markerStyle === 'outlined' ? "background-color: ".concat(this.markerColor) : undefined;
    }
  },
  watch: {
    $route: function $route() {
      this.getMarkerStyle();
    }
  },
  created: function created() {
    this.zoomToTwins = false;
    this.scrollByPolygonOnZoom = false;
    this.displayTwinPolygons = false;
    this.resetMapOnBoundsChange = true;
    this.defaultPitch = 50;
    this.getMarkerStyle();
    this.scrollByPolygonOnZoom = false;
  },
  methods: {
    getMarkerStyle: function getMarkerStyle() {
      var markerStyle = (get(this.$route, 'query.markerstyle') || 'default').toLowerCase();
      switch (markerStyle) {
        case 'outlined':
          this.markerStyle = 'outlined';
          break;
        default:
          this.markerStyle = 'default';
          break;
      }
    },
    editDtwin: function editDtwin(id) {
      this.$router.push({
        path: "/".concat(this.detailsBaseLink, "/").concat(id)
      });
    },
    openPopup: function openPopup(a) {
      this.markerItemClicked({
        component: a.component.$options.parent
      });
    },
    selectMarker: function selectMarker(e) {
      this.unSelectMarker();
      e.marker._element.classList.add('selected-marker');
    },
    unSelectMarker: function unSelectMarker() {
      var mapMarkers = document.querySelector('.mapboxgl-canvas-container').childNodes;
      mapMarkers.forEach(function (item) {
        if (item.classList.contains('selected-marker')) {
          item.classList.remove('selected-marker');
        }
      });
    }
  }
};